export default "__VITE_ASSET__324e2413__"